<template>
  <section class="update-password">
    <v-card class="elevation-12 card">
      <v-toolbar flat class="card-header">
        <v-icon>mdi-lock-reset</v-icon>
        <v-toolbar-title>Alterar senha</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="card-content">
        <p>Insira sua nova senha no campo abaixo e clique no botão para confirmar a alteração.</p>

        <v-alert outline color="error" icon="mdi-alert" :value="formUpdateFailed">
          {{formUpdateFailedMessage}}
        </v-alert>

        <v-form>
          <v-text-field
            v-model="password"
            name="password"
            label="Nova Senha"
            hint="Mínimo de 8 caracteres"
            min="8"
            :disabled="formUpdateLoading"
            :append-icon="hidePassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="() => (hidePassword = !hidePassword)"
            :type="hidePassword ? 'password' : 'text'" />
        </v-form>
      </v-card-text>

      <v-card-actions class="card-action">
        <v-spacer />
        <v-btn
          large
          color="success"
          :disabled="formUpdateLoading"
          :loading="formUpdateLoading"
          @click="update()">
          Confirmar
        </v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>

    <dialog-success-password />
  </section>
</template>

<script>
import PasswordService from '@/services/PasswordService';
import DialogSuccessPassword from '@/components/authentication/password/update/DialogSuccessPassword';

export default {
  name: 'FormUpdatePassword',
  components: {
    PasswordService,
    DialogSuccessPassword,
  },
  data() {
    return {
      hidePassword: true,
      password: '',
      formUpdateLoading: false,
      formUpdateFailed: false,
      formUpdateFailedMessage: '',
    };
  },
  methods: {
    update() {
      this.formUpdateFailed = false;
      this.formUpdateLoading = true;
      this.$store.dispatch('toggleUpdatePassword', true);
      const token = this.$props.token;

      PasswordService.update(this.password, token)
        .then((response) => {
          this.$store.dispatch('toggleUpdatePassword', true);
          this.formUpdateLoading = false;
          this.formUpdateSuccess = JSON.stringify(response);
        })
        .catch((error) => {
          this.formUpdateLoading = false;
          this.formUpdateFailed = true;
          this.formUpdateFailedMessage = error.response.data.join(', ');
        });
    },
  },
  props: ['token'],
};
</script>

<style scoped lang="scss">
.update-password {
  .card-content {
    padding: 2rem 4rem 0;
    max-width: 420px;
  }
  .card-action {
    padding: 1rem 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/authentication/password/FormUpdatePassword.vue